;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "EcoCash",
  props: ["xcsrftoken", "callback_url", "status_api_url", "request_type"],
  data: function data() {
    return {
      currency: null,
      logo: null,
      invoice_amount: null,
      agent_fee: 0,
      fee: 0,
      invoice_number: null,
      url: null,
      total_amount: 0,
      account_number: null,
      otp: null,
      loading: false,
      authorizing: false,
      proceedToAuthorize: false,
      authorized: false,
      account_input_has_error: false,
      otp_input_has_error: false,
      base_url: "",
      gateway: null,
      error_message: null,
      success_message: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.invoice_number = this.$attrs["invoice_no"];
    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.shortcode = this.$attrs["shortcode"];
    this.gateway = this.$attrs["gateway"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.url = this.$attrs["status_api_url"];
    this.logo = this.$attrs["logo"];
    this.base_url = this.$attrs["base_url"];
    this.gateway_id = this.$attrs["gid"];
    this.set_total_amount();
    $("#ecoCashModal").on("hidden.bs.modal", function () {
      _this.proceedToAuthorize = false;
      _this.account_number = null;
      _this.otp = null;
      _this.loading = false;
      _this.authorizing = false;
      _this.authorized = false;
      _this.error_message = null;
      _this.success_message = null;
      _this.destroyTimer();
    });
  },
  methods: {
    destroyTimer: function destroyTimer() {
      if (this.$refs.timer) {
        this.$refs.timer.destroyTimer();
      }
    },

    set_total_amount: function set_total_amount() {
      this.total_amount = parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee);
    },
    account_has_error: function account_has_error() {
      if (this.account_number && !this.account_number.match(/^\d+$/)) {
        this.account_input_has_error = true;
      } else {
        this.account_input_has_error = false;
      }
    },

    inititate_transaction: function inititate_transaction() {
      var _this2 = this;

      this.loading = true;
      this.error_message = null;
      var urlIs = this.base_url + "/api/payment/ecocash/checkout";
      var api_headers = {
        Authorization: ""
      };
      var params = {
        msisdn: this.account_number,
        gateway_id: this.gateway_id,
        amount: this.total_amount,
        invoice_number: this.invoice_number
      };
      Vue.axios.post(urlIs, params, {
        headers: api_headers
      }).then(function (response) {
        _this2.loading = false;
        _this2.account_number = null;
        _this2.proceedToAuthorize = true;
        _this2.success_message = "We have sent payment instructions to your phone. Click 'Complete' button below after you pay";
      }).catch(function () {
        _this2.loading = false;
        _this2.account_number = null;
        _this2.error_message = "Processing failed ! Try again later";
      }).then(function () {
        _this2.loading = false;
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"ecoCashModal","tabindex":"-1","role":"dialog","aria-labelledby":"ecoCashModallLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('form',[(_vm.error_message)?_c('p',{staticClass:"alert alert-danger"},[_vm._v("\n                        "+_vm._s(_vm.error_message)+"\n                      ")]):_vm._e(),_vm._v(" "),(_vm.success_message)?_c('p',{staticClass:"alert alert-success"},[_vm._v("\n                        "+_vm._s(_vm.success_message)+"\n                      ")]):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("Phone Number\n                        "),(_vm.account_input_has_error)?_c('span',{staticClass:"error"},[_vm._v("Invalid: Numbers only*")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account_number),expression:"account_number"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter your Phone Number","maxlength":"14","required":"true"},domProps:{"value":(_vm.account_number)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.account_number=$event.target.value},_vm.account_has_error]}})])]),_vm._v(" "),(!_vm.proceedToAuthorize)?_c('div',{staticClass:"\n                      card-footer\n                      d-flex\n                      justify-content-end\n                      align-items-center\n                    "},[_c('a',{staticClass:"pull-left btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"}},[_vm._v("Cancel")]),_vm._v(" "),(!_vm.loading && _vm.account_number)?_c('a',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.inititate_transaction}},[_vm._v("Proceed")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('a',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"href":"javascript:void(0)"}},[_vm._v("Please wait ...")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.proceedToAuthorize)?_c('div',{staticClass:"\n                      card-footer\n                      d-flex\n                      justify-content-end\n                      align-items-center\n                    "},[_c('a',{staticClass:"pull-left btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.proceedToAuthorize)?_c('complete-button',{ref:"timer",attrs:{"gateway":"ecocash","poll_external":"true","gateway_id":_vm.gateway_id,"status_api_url":_vm.status_api_url,"invoice_no":_vm.invoice_number,"callback_url":_vm.callback_url}}):_vm._e()],1):_vm._e()])])])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay Using EcoCash Account")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-035a5e76", __vue__options__)
  } else {
    hotAPI.reload("data-v-035a5e76", __vue__options__)
  }
})()}